import { render, staticRenderFns } from "./PacksWizard.vue?vue&type=template&id=b281bc7e&"
import script from "./PacksWizard.vue?vue&type=script&lang=js&"
export * from "./PacksWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports